import { DatePipe, LowerCasePipe } from "@angular/common";
import { Component, input } from "@angular/core";
import { PopoverDirective } from "@kno2/common/directives";
import { UserMessageEvent } from "@kno2/data-access/users";

@Component({
    selector: "kno2-signatures-status-cell-content",
    imports: [PopoverDirective, LowerCasePipe, DatePipe],
    templateUrl: "./signatures-status-cell-content.component.html",
    styles: `
        .dropdown-menu-absolute {
            position: absolute;
            top: 100%;
            left: 0;
            transform: translate3d(0, 0, 0);
            z-index: 1050; /* Ensure it appears above other elements */
        }
    `
})
export class SignaturesStatusCellContentComponent {
    public event = input.required<UserMessageEvent>();
}
